<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入任务类型查询"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="() => { this.queryObj.pageNum = 1; init() }">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>

      <es-delete @del="del()"
                 type="button"></es-delete>

    </div>
    <el-table :data="pageData.list"
              ref="typeTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              style="cursor: pointer;"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="name"
                       label="任务类型">
      </el-table-column>
      <el-table-column prop="certiName"
                       label="证书名称">
      </el-table-column>
      <el-table-column prop="traiName"
                       label="培训名称">
      </el-table-column>
      <el-table-column prop="attachName"
                       label="附件名称">
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadTypeList() }">
      </es-pagination>
    </div>

    <!--编辑设备类型-->
    <el-dialog :close-on-click-modal="false"
               :visible.sync="editVisible"
               @closed="refclose()"
               width="700px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑任务类型
      </span>
      <el-form :model="typeInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="typeForm">
        <el-form-item prop="name"
                      label="任务类型">
          <el-input v-model="typeInfo.name"
                    placeholder="请输入任务类型"
                    style="width:200px"
                    clearable
                    size="medium ">
          </el-input>
        </el-form-item>
        <el-form-item prop="certiName"
                      label="证书类型">
          <SelectInput :options="certi"
                       v-model="certivalue"
                       placeholder="请选择证书类型"
                       style="width:300px" />
        </el-form-item>
        <el-form-item prop="traiName"
                      label="培训类型">
          <SelectInput :options="culti"
                       v-model="cultivalue"
                       placeholder="请选择培训类型"
                       style="width:300px" />
        </el-form-item>
        <el-form-item prop="attachName"
                      label="附件">
          <div v-for="(attachment, index) in attachments"
               :key="index">
            <el-input v-model="attachment.name"
                      placeholder="请输入附件名称"
                      style="width:200px;padding-top:5px;"
                      clearable
                      size="medium "></el-input>
            <el-link :underline="false"
                     title="删除"
                     style="margin-left: 10px;"
                     type="primary"
                     @click="removeAttachment(index)"><i class="el-icon-remove-outline"
                 v-show="index > 0"></i></el-link>

            <el-link :underline="false"
                     title="添加"
                     style="margin-left: 10px;"
                     type="primary"
                     @click="addAttachment()"><i class="el-icon-circle-plus"
                 v-show="attachments.length-index < 2"></i></el-link>
          </div>

        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false;certivalue=[];cultivalue=[]">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitType()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>



<script>
import SelectInput from '../select-input.vue'
export default {
  name: 'certificate',
  props: ["funcs"],
  components: { SelectInput },
  data () {
    return {
      attachments: [{ name: '' }],
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      typeInfo: {},//设备类型信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入任务类型', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        certiName: [
          { required: false, message: '请选择证书类型', trigger: 'blur' }
        ],
        traiName: [
          { required: false, message: '请选择培训类型', trigger: 'blur' }
        ],
        attachName: [
          { required: false, message: '请输入附件名称', trigger: 'blur' }
        ],
      },
      loading: false,
      saving: false,
      certi: [],
      culti: [],
      certivalue: [],
      cultivalue: []
    }
  },
  methods: {
    addAttachment () {
      this.attachments.push({ name: '' });
    },
    removeAttachment (index) {
      this.attachments.splice(index, 1);
    },
    submitForm () {
      const attachmentNames = this.attachments
        .filter(attachment => attachment.name !== '')
        .map(attachment => attachment.name)
        .join(',');
      console.log(attachmentNames);
    },
    //页面初始化
    init () {
      this.loadTypeList()
      this.loadCultiListAll()
      this.loadCertiListAll()
    },
    //从后台查询设备类型
    loadTypeList () {
      this.loading = true
      this.$ajax.get('/buss/tasktype/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化证书类型下拉框
    loadCertiListAll () {
      this.$ajax.get('/base/certi/list_all').then(msg => {
        this.certi = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //初始化培训类型下拉框
    loadCultiListAll () {
      this.$ajax.get('/base/culti/list_all').then(msg => {
        this.culti = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //初始化添加设备类型
    add_init () {
      this.editVisible = true
      this.typeInfo = {
      }
    },
    //初始化编辑设备类型
    edit_init (row) {
      this.editVisible = true
      this.typeInfo = JSON.parse(JSON.stringify(row))
      console.log(row)
      const certiId = row.certiId.split(',');
      const certiName = row.certiName.split(',');
      const certiCount = row.certiCount.split(',');
      const traiId = row.traiId.split(',');
      const traiName = row.traiName.split(',');
      const traiCount = row.traiCount.split(',');
      const attachName = row.attachName.split(',');

      this.certivalue.splice(0)
      const cultiresult = [];
      const attachments = [];
      for (let i = 0; i < certiName.length; i++) {
        this.certivalue.push({ name: certiName[i], id: certiId[i], count: certiCount[i] });
      }
      for (let i = 0; i < traiName.length; i++) {
        cultiresult.push({ name: traiName[i], id: traiId[i], count: traiCount[i] });
      }
      for (let i = 0; i < attachName.length; i++) {
        attachments.push({ name: attachName[i] });
      }
      console.log(this.certivalue)
      this.cultivalue = cultiresult
      this.attachments = attachments
      console.log(this.cultivalue)
    },
    //保存设备类型
    submitType () {
      console.log(this.typeInfo)
      if (this.certivalue.length > 0) {
        // 使用map方法遍历数组，将name和count组成新的对象
        const certiName = this.certivalue.map(obj => ({ name: obj.name })).map(obj => obj.name).join(',');
        const certicount = this.certivalue.map(obj => ({ count: obj.count })).map(obj => obj.count).join(',');
        const certiid = this.certivalue.map(obj => ({ id: obj.id })).map(obj => obj.id).join(',');

        this.$set(this.typeInfo, "certiName", certiName)
        this.$set(this.typeInfo, "certiCount", certicount)
        this.$set(this.typeInfo, "certiId", certiid)
      }
      if (this.cultivalue.length > 0) {
        // 使用map方法遍历数组，将name和count组成新的对象
        const certiName = this.cultivalue.map(obj => ({ name: obj.name })).map(obj => obj.name).join(',');
        const certicount = this.cultivalue.map(obj => ({ count: obj.count })).map(obj => obj.count).join(',');
        const certiid = this.cultivalue.map(obj => ({ id: obj.id })).map(obj => obj.id).join(',');

        this.$set(this.typeInfo, "traiName", certiName)
        this.$set(this.typeInfo, "traiCount", certicount)
        this.$set(this.typeInfo, "traiId", certiid)
      }
      if (this.attachments.length > 0) {
        console.log(this.attachments)
        const attachmentNames = this.attachments
          .filter(attachment => attachment.name !== '')
          .map(attachment => attachment.name)
          .join(',');

        this.$set(this.typeInfo, "attachName", attachmentNames)
      }
      this.$refs["typeForm"].validate(valid => {
        if (valid) {
          let url = "/buss/tasktype/add";
          if (this.typeInfo.id != null) {
            url = "/buss/tasktype/edit";
          }

          this.saving = true
          this.$ajax.post(url, this.typeInfo).then(msg => {
            this.saving = false
            this.cultivalue = []
            this.certivalue = []
            this.attachments = [{ name: '' }]
            this.loadTypeList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除设备类型
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["typeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/tasktype/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadTypeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },
    refclose () {
      this.$refs['typeForm'].clearValidate();
      this.cultivalue = []
      this.certivalue = []
      this.attachments = [{ name: '' }]
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
